import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Defaults } from '../../shared/defaults/defaults';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss']
})
export class ErrorPageComponent implements OnInit {
  constructor(private location: Location) {}
  contactPhone!: string;

  ngOnInit(): void {
    this.contactPhone = Defaults.contactUsNumber;
  }

  navigateToPrevScreen(): void {
    this.location.historyGo(-2);
  }
}
